<script lang="ts">
	import { isFilled } from '@prismicio/client';
	import { PrismicImage, PrismicLink, PrismicRichText } from '@prismicio/svelte';
	import Wordmark from './Wordmark.svelte';
	import { getFormattedDate, siteDateFormat, newsDateFormat } from '$lib/helpers/app.documents';

	const { article } = $props();
</script>

<article class="news-card">
	<PrismicLink field={article} class="news-card__link" />

	<div class="news-card__image--container">
		<div class="news-card__image--background">
			<Wordmark />
		</div>

		{#if isFilled.image(article.data.image)}
			<PrismicImage field={article.data.image} class="news-card__image" loading="lazy" />
		{/if}
	</div>

	<div class="news-card__content">
		<div class="news-card__content--date">
			{getFormattedDate(article.data.publish_date, siteDateFormat, newsDateFormat)}
		</div>

		{#if isFilled.richText(article.data.title)}
			<div class="news-card__content--title">
				<PrismicRichText field={article.data.title} />
			</div>
		{/if}

		<div class="btn btn-sm btn-primary">Read more</div>
	</div>
</article>
